<template>
  <div>
    <page-pc v-if="!isMobile"></page-pc>
    <page-mobile v-else></page-mobile>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import PagePc from "./Pc"
import PageMobile from "./Mobile"

export default {
  name: 'IndexPage',
  components: {
    PagePc,
    PageMobile
  },
  props: {},
  data: function () {
    return {
    }
  },
  created() {

  },
  mounted() {
  },
  unmounted() {
  },
  computed: {
    ...mapGetters([
        "isMobile"
    ]),
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">
.page {

}
</style>
